const quickNews: {
  id: string;
  title: string;
  publishedDate: string;
  readTime: string;
  img: string;
}[] = [
  {
    id: "1",
    title: "Quick Article 1",
    publishedDate: "Jan 22nd 2023",
    readTime: "8min",
    img: "../../images/trending/trending_1.jpg",
  },
  {
    id: "2",
    title: "Quick Article 2",
    publishedDate: "Feb 12th 2023",
    readTime: "7min",
    img: "../../images/trending/trending_2.jpg",
  },
  {
    id: "3",
    title: "Quick Article 3",
    publishedDate: "Mar 01st 2023",
    readTime: "12min",
    img: "../../images/trending/trending_3.jpg",
  },
  {
    id: "4",
    title: "Quick Article 4",
    publishedDate: "Jan 29th 2023",
    readTime: "20min",
    img: "../../images/trending/trending_4.jpg",
  },
  {
    id: "5",
    title: "Quick Article 5",
    publishedDate: "Jan 14th 2023",
    readTime: "3min",
    img: "../../images/trending/trending_5.jpg",
  },
];

export default quickNews;
